export default {
    OrderShortageManagement: {
        Order: 'Order No.',
        number: 'Third-party/internal Order No., separated by commas',
        name: 'Product name/code',
        SKU: 'SKU',
        source: 'Order Source',
        Buyer: 'Buyer nickname',
        Consignee: 'Consignee name',
        mobile: 'Consignee phone number',
        comments: "Buyer's Comments",
        Notes: "Merchant's Comments",
        there: 'Presence of gifts',
        party: '3rd Party Order Time',
        Start: 'Start date',
        End: 'End date',
        Payment: 'Payment time',
        Internal: 'Internal Creation Time',
        time: 'Estimated delivery time',
        reallocate: 'Reallocate',
        form: {
            number: 'Customer Order No.',
            order: 'CSG Order No.',
            Label: 'Label',
            Status: 'Review status',
            Sales: 'Store',
            channel: 'Sales Channel',
            source: 'Order Source',
            line: 'Number of Item Lines',
            Shortage: 'Number of out-of-stock items',
            nickname: 'Buyer nickname',
            comments: "Buyer's Comments",
            Merchant: "Merchant's Comments",
            name: 'Consignee name',
            mobile: 'Consignee phone number',
            address: 'Consignee address',
            amount: 'Total amount of goods',
            Buyer: 'Amount payable by buyer',
            cost: 'Total cost of goods',
            party: '3rd Party Order Time',
            Payment: 'Payment time',
            creation: 'Internal Creation Time',
            delivery: 'Estimated delivery time',
            Pending: 'Suspend Status',
            there: 'Presence of gifts',
            Product: 'Product Information',
        }
    }
};
